import { computed, ref } from "vue";
import { useDialog } from "primevue/usedialog";
import type { DynamicDialogInstance } from "primevue/dynamicdialogoptions";
import ClickUpSettingsDialog from "@/components/dialogs/ClickUpSettingsDialog.vue";

export const useClickUpSettingsDialog = () => {
    const dialog = useDialog();
    const dialogRef = ref<DynamicDialogInstance & { visible?: boolean }>();

    const open = () => {
        dialogRef.value = dialog.open(ClickUpSettingsDialog, {
            props: {
                header: "ClickUp Integration Settings",
                style: {
                    maxWidth: "500px",
                    width: "80%",
                },
                modal: true,
                maximizable: false,
                draggable: false,
            },
            onClose: () => {
                dialogRef.value = undefined;
            },
        });
    };

    return {
        open,
        isVisible: computed(() => Boolean(dialogRef.value?.visible)),
    };
};
